import type { User } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { ConsoleLayout } from "./components/ConsoleLayout";
import { EmptyPane } from "./components/EmptyPane";
import { CustomersScreen } from "./screens/CustomersScreen";
import { QueueScreen } from "./screens/QueueScreen";
import { CustomerWorkspace } from "./screens/QueueScreen/CustomerWorkspace";
import { TasksScreen } from "./screens/TasksScreen";

export interface ClinicRoutesProps {
  user: User;
  onSignOut: () => void;
}

export function ClinicRoutes({ user, onSignOut }: ClinicRoutesProps) {
  const { t } = useTranslation("clinic");

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ConsoleLayout user={user} onSignOut={onSignOut} />}>
          <Route index element={<Navigate to="/queue" replace />} />
          <Route path="queue" element={<QueueScreen />}>
            <Route
              index
              element={
                <EmptyPane
                  title={t("queueScreen.emptyTitle", "Select a customer.")}
                  body={t("queueScreen.emptyBody", "Open someone from the queue to work on them.")}
                />
              }
            />
            <Route path=":customerId" element={<CustomerWorkspace />} />
          </Route>
          <Route path="customers" element={<CustomersScreen />} />
          <Route path="tasks" element={<TasksScreen />} />
          <Route path="*" element={<Navigate to="/queue" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
